import { render } from "./SimpleKeyboardNum.vue?vue&type=template&id=5b980a0f"
import script from "./SimpleKeyboardNum.vue?vue&type=script&lang=js"
export * from "./SimpleKeyboardNum.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__